export default {"src":"/_next/static/media/bringtable-icon.c072dbec.svg","height":802,"width":802,"blurWidth":0,"blurHeight":0};